import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

const MappingModeToggle = ({ value, onChange, disabled }) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    value={value}
    onChange={(_, nextMode) => {
      if (nextMode) {
        onChange(nextMode);
      }
    }}
    disabled={disabled}
  >
    <ToggleButton value="simple">Simple</ToggleButton>
    <ToggleButton value="advanced">Advanced</ToggleButton>
  </ToggleButtonGroup>
);

export default MappingModeToggle;
